import { LifeInsuranceCalculatorCalculationList } from 'admin/calculators/LifeInsuranceCalculatorCalculation/LifeInsuranceCalculatorCalculationList';
import { LifeInsuranceCalculatorCalculationShow } from 'admin/calculators/LifeInsuranceCalculatorCalculation/LifeInsuranceCalculatorCalculationShow';
import { MortgageCalculatorCalculationList } from 'admin/calculators/MortgageCalculatorCalculation/MortgageCalculatorCalculationList';
import { MortgageCalculatorCalculationShow } from 'admin/calculators/MortgageCalculatorCalculation/MortgageCalculatorCalculationShow';
import { CashFlowAdjustmentCreate } from 'admin/cashFlowAdjustment/CashFlowAdjustmentCreate';
import { CashFlowAdjustmentEdit } from 'admin/cashFlowAdjustment/CashFlowAdjustmentEdit';
import { CashFlowAdjustmentShow } from 'admin/cashFlowAdjustment/CashFlowAdjustmentShow';
import { ClientNoteCreate } from 'admin/clientNotes/ClientNoteCreate';
import { ClientNoteEdit } from 'admin/clientNotes/ClientNoteEdit';
import { ClientNoteList } from 'admin/clientNotes/ClientNoteList';
import { ClientNoteShow } from 'admin/clientNotes/ClientNoteShow';
import { ClientEdit } from 'admin/clients/ClientEdit';
import { ClientList } from 'admin/clients/ClientList';
import { ClientShow } from 'admin/clients/ClientShow';
import { Dashboard } from 'admin/dashboard/Dashboard';
import { FinancialAdvisorTaskCreate } from 'admin/financialAdvisorTask/FinancialAdvisorTaskCreate';
import { FinancialAdvisorTaskList } from 'admin/financialAdvisorTask/FinancialAdvisorTaskList';
import { FinancialAdvisorTaskShow } from 'admin/financialAdvisorTask/FinancialAdvisorTaskShow';
import { FinancialReserveCreate } from 'admin/financialReserve/FinancialReserveCreate';
import { FinancialReserveEdit } from 'admin/financialReserve/FinancialReserveEdit';
import { FinancialReserveShow } from 'admin/financialReserve/FinancialReserveShow';
import { useI18nextProvider } from 'admin/i18n/useI18nextProvider';
import { CustomLayout } from 'admin/layout/CustomLayout';
import { PerformanceDataList } from 'admin/performanceData/PerformanceDataList';
import { LifeInsuranceAuditProcessList } from 'admin/processes/LifeInsuranceAuditProcess/LifeInsuranceAuditProcessList';
import { LifeInsurancePurchaseProcessList } from 'admin/processes/LifeInsurancePurchaseProcess/LifeInsurancePurchaseProcessList';
import { MortgagePurchaseProcessList } from 'admin/processes/MortgagePurchaseProcess/MortgagePurchaseProcessList';
import { MortgageRefinanceProcessList } from 'admin/processes/MortgageRefinanceProcess/MortgageRefinanceProcessList';
import { BuildingSavingsProductCreate } from 'admin/products/BuildingSavingsProduct/BuildingSavingsProductCreate';
import { BuildingSavingsProductEdit } from 'admin/products/BuildingSavingsProduct/BuildingSavingsProductEdit';
import { BuildingSavingsProductList } from 'admin/products/BuildingSavingsProduct/BuildingSavingsProductList';
import { BuildingSavingsProductShow } from 'admin/products/BuildingSavingsProduct/BuildingSavingsProductShow';
import { CollisionInsuranceProductCreate } from 'admin/products/CollisionInsuranceProduct/CollisionInsuranceProductCreate';
import { CollisionInsuranceProductEdit } from 'admin/products/CollisionInsuranceProduct/CollisionInsuranceProductEdit';
import { CollisionInsuranceProductList } from 'admin/products/CollisionInsuranceProduct/CollisionInsuranceProductList';
import { CollisionInsuranceProductShow } from 'admin/products/CollisionInsuranceProduct/CollisionInsuranceProductShow';
import { CreditCardProductCreate } from 'admin/products/CreditCardProduct/CreditCardProductCreate';
import { CreditCardProductEdit } from 'admin/products/CreditCardProduct/CreditCardProductEdit';
import { CreditCardProductList } from 'admin/products/CreditCardProduct/CreditCardProductList';
import { CreditCardProductShow } from 'admin/products/CreditCardProduct/CreditCardProductShow';
import { GenericInsuranceProductCreate } from 'admin/products/GenericInsuranceProduct/GenericInsuranceProductCreate';
import { GenericInsuranceProductEdit } from 'admin/products/GenericInsuranceProduct/GenericInsuranceProductEdit';
import { GenericInsuranceProductList } from 'admin/products/GenericInsuranceProduct/GenericInsuranceProductList';
import { GenericInsuranceProductShow } from 'admin/products/GenericInsuranceProduct/GenericInsuranceProductShow';
import { GenericProductCreate } from 'admin/products/GenericProduct/GenericProductCreate';
import { GenericProductEdit } from 'admin/products/GenericProduct/GenericProductEdit';
import { GenericProductList } from 'admin/products/GenericProduct/GenericProductList';
import { GenericProductShow } from 'admin/products/GenericProduct/GenericProductShow';
import { InvestmentProductCreate } from 'admin/products/InvestmentProduct/InvestmentProductCreate';
import { InvestmentProductEdit } from 'admin/products/InvestmentProduct/InvestmentProductEdit';
import { InvestmentProductList } from 'admin/products/InvestmentProduct/InvestmentProductList';
import { InvestmentProductShow } from 'admin/products/InvestmentProduct/InvestmentProductShow';
import { LifeInsuranceProductCreate } from 'admin/products/LifeInsuranceProduct/LifeInsuranceProductCreate';
import { LifeInsuranceProductEdit } from 'admin/products/LifeInsuranceProduct/LifeInsuranceProductEdit';
import { LifeInsuranceProductList } from 'admin/products/LifeInsuranceProduct/LifeInsuranceProductList';
import { LifeInsuranceProductShow } from 'admin/products/LifeInsuranceProduct/LifeInsuranceProductShow';
import { LoanProductCreate } from 'admin/products/LoanProduct/LoanProductCreate';
import { LoanProductEdit } from 'admin/products/LoanProduct/LoanProductEdit';
import { LoanProductList } from 'admin/products/LoanProduct/LoanProductList';
import { LoanProductShow } from 'admin/products/LoanProduct/LoanProductShow';
import { MortgageProductCreate } from 'admin/products/MortgageProduct/MortgageProductCreate';
import { MortgageProductEdit } from 'admin/products/MortgageProduct/MortgageProductEdit';
import { MortgageProductList } from 'admin/products/MortgageProduct/MortgageProductList';
import { MortgageProductShow } from 'admin/products/MortgageProduct/MortgageProductShow';
import { MotorLiabilityInsuranceProductCreate } from 'admin/products/MotorLiabilityInsuranceProduct/MotorLiabilityInsuranceProductCreate';
import { MotorLiabilityInsuranceProductEdit } from 'admin/products/MotorLiabilityInsuranceProduct/MotorLiabilityInsuranceProductEdit';
import { MotorLiabilityInsuranceProductList } from 'admin/products/MotorLiabilityInsuranceProduct/MotorLiabilityInsuranceProductList';
import { MotorLiabilityInsuranceProductShow } from 'admin/products/MotorLiabilityInsuranceProduct/MotorLiabilityInsuranceProductShow';
import { PropertyInsuranceProductCreate } from 'admin/products/PropertyInsuranceProduct/PropertyInsuranceProductCreate';
import { PropertyInsuranceProductEdit } from 'admin/products/PropertyInsuranceProduct/PropertyInsuranceProductEdit';
import { PropertyInsuranceProductList } from 'admin/products/PropertyInsuranceProduct/PropertyInsuranceProductList';
import { PropertyInsuranceProductShow } from 'admin/products/PropertyInsuranceProduct/PropertyInsuranceProductShow';
import { RetirementPensionSavingsProductCreate } from 'admin/products/RetirementPensionSavingsProduct/RetirementPensionSavingsProductCreate';
import { RetirementPensionSavingsProductEdit } from 'admin/products/RetirementPensionSavingsProduct/RetirementPensionSavingsProductEdit';
import { RetirementPensionSavingsProductList } from 'admin/products/RetirementPensionSavingsProduct/RetirementPensionSavingsProductList';
import { RetirementPensionSavingsProductShow } from 'admin/products/RetirementPensionSavingsProduct/RetirementPensionSavingsProductShow';
import { SavingsProductCreate } from 'admin/products/SavingsProduct/SavingsProductCreate';
import { SavingsProductEdit } from 'admin/products/SavingsProduct/SavingsProductEdit';
import { SavingsProductList } from 'admin/products/SavingsProduct/SavingsProductList';
import { SavingsProductShow } from 'admin/products/SavingsProduct/SavingsProductShow';
import { SupplementaryPensionSavingsProductCreate } from 'admin/products/SupplementaryPensionSavingsProduct/SupplementaryPensionSavingsProductCreate';
import { SupplementaryPensionSavingsProductEdit } from 'admin/products/SupplementaryPensionSavingsProduct/SupplementaryPensionSavingsProductEdit';
import { SupplementaryPensionSavingsProductList } from 'admin/products/SupplementaryPensionSavingsProduct/SupplementaryPensionSavingsProductList';
import { SupplementaryPensionSavingsProductShow } from 'admin/products/SupplementaryPensionSavingsProduct/SupplementaryPensionSavingsProductShow';
import { ReportCreate } from 'admin/reports/ReportCreate';
import { ReportEdit } from 'admin/reports/ReportEdit';
import { ReportList } from 'admin/reports/ReportList';
import { ReportShow } from 'admin/reports/ReportShow';
import { dataProvider } from 'admin/resourceDataProviders/dataProvider';
import { StaffEdit } from 'admin/staff/StaffEdit';
import { StaffList } from 'admin/staff/StaffList';
import { StaffShow } from 'admin/staff/StaffShow';
import { adminTheme } from 'admin/themes/adminTheme';
import { UserInvitationCreate } from 'admin/userInvitations/UserInvitationCreate';
import { UserInvitationEdit } from 'admin/userInvitations/UserInvitationEdit';
import { UserInvitationList } from 'admin/userInvitations/UserInvitationList';
import { UserInvitationShow } from 'admin/userInvitations/UserInvitationShow';
import { UserProfileEdit } from 'admin/userProfile/UserProfileEdit';
import { UserRelationCreate } from 'admin/userRelations/UserRelationCreate';
import { UserRelationEdit } from 'admin/userRelations/UserRelationEdit';
import { UserRelationList } from 'admin/userRelations/UserRelationList';
import { UserRelationShow } from 'admin/userRelations/UserRelationShow';
import { UserEdit } from 'admin/users/UserEdit';
import { UserList } from 'admin/users/UserList';
import { UserShow } from 'admin/users/UserShow';
import { Loading } from 'common/components/Loading/Loading';
import { AuthContext } from 'common/providers/AuthContextProvider/AuthContextProvider';
import { Role, useCurrentUserQuery } from 'generated/graphql';
import { useContext } from 'react';
import { Admin, CustomRoutes, Resource } from 'react-admin';
import { Route } from 'react-router-dom';

import { NotFoundPage } from './NotFoundPage';

export const AdminPage: React.FC = () => {
  const { isAuthenticated, isLoading: loadingAuth } = useContext(AuthContext);
  const { data, loading: loadingUser } = useCurrentUserQuery({ skip: !isAuthenticated });
  const i18nextProvider = useI18nextProvider();

  if (loadingAuth || loadingUser || !dataProvider) return <Loading fullScreen messages={[]} />;

  const staffRoles = [Role.RoleAdmin, Role.RoleFinancialAdvisor, Role.RoleScout];

  const hasAnyRole = (allowedRoles: Role[]) =>
    isAuthenticated && data?.user?.roles?.some((role) => allowedRoles.includes(role));

  // TODO: replace this workarounds with proper auth context (which will includes roles)
  if (!hasAnyRole(staffRoles)) return <NotFoundPage />;

  return (
    <Admin
      basename="/admin"
      dashboard={Dashboard}
      dataProvider={dataProvider}
      i18nProvider={i18nextProvider}
      layout={CustomLayout}
      theme={adminTheme}
    >
      <Resource edit={ClientEdit} list={ClientList} name="Client" options={{ label: 'Klienti' }} show={ClientShow} />
      <Resource edit={StaffEdit} list={StaffList} name="Staff" options={{ label: 'Pracovníci' }} show={StaffShow} />
      <Resource
        create={FinancialAdvisorTaskCreate}
        list={FinancialAdvisorTaskList}
        name="FinancialAdvisorTask"
        options={{ label: 'Úlohy' }}
        show={FinancialAdvisorTaskShow}
      />
      <Resource
        create={UserInvitationCreate}
        edit={UserInvitationEdit}
        list={UserInvitationList}
        name="UserInvitation"
        options={{ label: 'Pozvánky používateľov' }}
        show={UserInvitationShow}
      />
      <Resource
        create={BuildingSavingsProductCreate}
        edit={BuildingSavingsProductEdit}
        list={BuildingSavingsProductList}
        name="BuildingSavingsProduct"
        options={{ label: 'Stavebné sporenie' }}
        show={BuildingSavingsProductShow}
      />
      <Resource
        create={CollisionInsuranceProductCreate}
        edit={CollisionInsuranceProductEdit}
        list={CollisionInsuranceProductList}
        name="CollisionInsuranceProduct"
        options={{ label: 'Havarijné poistenie' }}
        show={CollisionInsuranceProductShow}
      />
      <Resource
        create={CreditCardProductCreate}
        edit={CreditCardProductEdit}
        list={CreditCardProductList}
        name="CreditCardProduct"
        options={{ label: 'Kreditná karta' }}
        show={CreditCardProductShow}
      />
      <Resource
        create={GenericInsuranceProductCreate}
        edit={GenericInsuranceProductEdit}
        list={GenericInsuranceProductList}
        name="GenericInsuranceProduct"
        options={{ label: 'Poistenie' }}
        show={GenericInsuranceProductShow}
      />
      <Resource
        create={GenericProductCreate}
        edit={GenericProductEdit}
        list={GenericProductList}
        name="GenericProduct"
        options={{ label: 'Iný finančný produkt' }}
        show={GenericProductShow}
      />
      <Resource
        create={InvestmentProductCreate}
        edit={InvestmentProductEdit}
        list={InvestmentProductList}
        name="InvestmentProduct"
        options={{ label: 'Investičný produkt' }}
        show={InvestmentProductShow}
      />
      <Resource
        create={LifeInsuranceProductCreate}
        edit={LifeInsuranceProductEdit}
        list={LifeInsuranceProductList}
        name="LifeInsuranceProduct"
        options={{ label: 'Životné poistenie' }}
        show={LifeInsuranceProductShow}
      />
      <Resource
        create={LoanProductCreate}
        edit={LoanProductEdit}
        list={LoanProductList}
        name="LoanProduct"
        options={{ label: 'Úver' }}
        show={LoanProductShow}
      />
      <Resource
        create={MortgageProductCreate}
        edit={MortgageProductEdit}
        list={MortgageProductList}
        name="MortgageProduct"
        options={{ label: 'Hypotéka' }}
        show={MortgageProductShow}
      />
      <Resource
        create={MotorLiabilityInsuranceProductCreate}
        edit={MotorLiabilityInsuranceProductEdit}
        list={MotorLiabilityInsuranceProductList}
        name="MotorLiabilityInsuranceProduct"
        options={{ label: 'PZP' }}
        show={MotorLiabilityInsuranceProductShow}
      />
      <Resource
        create={PropertyInsuranceProductCreate}
        edit={PropertyInsuranceProductEdit}
        list={PropertyInsuranceProductList}
        name="PropertyInsuranceProduct"
        options={{ label: 'Poistenie majetku' }}
        show={PropertyInsuranceProductShow}
      />
      <Resource
        create={RetirementPensionSavingsProductCreate}
        edit={RetirementPensionSavingsProductEdit}
        list={RetirementPensionSavingsProductList}
        name="RetirementPensionSavingsProduct"
        options={{ label: 'Starobné dôchodkové sporenie' }}
        show={RetirementPensionSavingsProductShow}
      />
      <Resource
        create={SavingsProductCreate}
        edit={SavingsProductEdit}
        list={SavingsProductList}
        name="SavingsProduct"
        options={{ label: 'Sporenie' }}
        show={SavingsProductShow}
      />
      <Resource
        create={SupplementaryPensionSavingsProductCreate}
        edit={SupplementaryPensionSavingsProductEdit}
        list={SupplementaryPensionSavingsProductList}
        name="SupplementaryPensionSavingsProduct"
        options={{ label: 'Doplnkové dôchodkové sporenie' }}
        show={SupplementaryPensionSavingsProductShow}
      />
      <Resource
        list={MortgagePurchaseProcessList}
        name="MortgagePurchaseProcess"
        options={{ label: 'Nová hypotéka' }}
      />
      <Resource
        list={MortgageRefinanceProcessList}
        name="MortgageRefinanceProcess"
        options={{ label: 'Refinancovanie hypotéky' }}
      />
      <Resource
        list={LifeInsurancePurchaseProcessList}
        name="LifeInsurancePurchaseProcess"
        options={{ label: 'Nové životné poistenie' }}
      />
      <Resource
        list={LifeInsuranceAuditProcessList}
        name="LifeInsuranceAuditProcess"
        options={{ label: 'Audit životného poistenia' }}
      />
      <Resource
        list={MortgageCalculatorCalculationList}
        name="MortgageCalculatorCalculation"
        options={{ label: 'Kalkulačka maximálnej hypotéky' }}
        show={MortgageCalculatorCalculationShow}
      />
      <Resource
        list={LifeInsuranceCalculatorCalculationList}
        name="LifeInsuranceCalculatorCalculation"
        options={{ label: 'Kalkulačka potreby životného poistenia' }}
        show={LifeInsuranceCalculatorCalculationShow}
      />
      <Resource
        create={ClientNoteCreate}
        edit={ClientNoteEdit}
        list={ClientNoteList}
        name="ClientNote"
        options={{ label: 'Poznámky' }}
        show={ClientNoteShow}
      />
      <Resource edit={UserEdit} list={UserList} name="User" options={{ label: 'Používatelia' }} show={UserShow} />
      <Resource
        create={UserRelationCreate}
        edit={UserRelationEdit}
        list={UserRelationList}
        name="UserRelation"
        options={{ label: 'Vzťahy používateľov' }}
        show={UserRelationShow}
      />
      <Resource
        create={ReportCreate}
        edit={ReportEdit}
        list={ReportList}
        name="Report"
        options={{ label: 'Výstupy' }}
        show={ReportShow}
      />
      <Resource
        create={FinancialReserveCreate}
        edit={FinancialReserveEdit}
        name="FinancialReserve"
        options={{ label: 'Finančná rezerva' }}
        show={FinancialReserveShow}
      />
      <Resource
        create={CashFlowAdjustmentCreate}
        edit={CashFlowAdjustmentEdit}
        name="CashFlowAdjustment"
        options={{ label: 'Cash flow' }}
        show={CashFlowAdjustmentShow}
      />
      <Resource list={PerformanceDataList} name="SalvePerformanceData" options={{ label: 'Výkonnosť' }} />
      <CustomRoutes>
        <Route element={<UserProfileEdit />} path="/Profile" />
      </CustomRoutes>
    </Admin>
  );
};
